// extracted by mini-css-extract-plugin
export var button = "_d7-4";
export var hasDarkBackground = "_d7-7";
export var hasLightBackground = "_d7-6";
export var iconWrapper = "_d7-0";
export var large = "_d7-2";
export var medium = "_d7-1";
export var small = "_d7-5";
export var xsmall = "_d7-3";